import { IAppState } from '../app.state';
import { createSelector } from '@ngrx/store';
import { IThemeState } from '@myStore/theme/theme.state';

const selectNotificationsState = (state: IAppState) => state.theme;
export const selectTheme = createSelector(
  selectNotificationsState,
  (state: IThemeState) => state?.theme
);
